import { Params } from '../../core/adaptor';
import { getTooltipMapping } from '../../utils/tooltip';
import { deepAssign } from '../../utils';
import { geometry, MappingOptions, GeometryOptions } from './base';

export interface PolygonGeometryOptions extends GeometryOptions {
  /** x è½´å­æ®µ */
  readonly xField?: string;
  /** y è½´å­æ®µ */
  readonly yField?: string;
  /** åç»å­æ®µ */
  readonly seriesField?: string;
  /** point å¾å½¢æ å°è§å */
  readonly polygon?: MappingOptions;
}

/**
 * polygon çéç½®å¤ç
 * @param params
 */
export function polygon<O extends PolygonGeometryOptions>(params: Params<O>): Params<O> {
  const { options } = params;
  const { polygon, xField, yField, seriesField, tooltip } = options;

  const { fields, formatter } = getTooltipMapping(tooltip, [xField, yField, seriesField]);

  return polygon
    ? geometry(
        deepAssign({}, params, {
          options: {
            type: 'polygon',
            colorField: seriesField,
            tooltipFields: fields,
            mapping: {
              tooltip: formatter,
              ...polygon,
            },
          },
        })
      )
    : params;
}
